<template>
  <div>
    <Header @addNewQuestion="addNewQuestion()" @addNewSection="addNewSection()" />
    <div class="mainContainer" v-if="toggleMainDiv">
      <div v-for="(section, sectinIndex) in groups" :key="sectinIndex">
        <div
          v-if="groups[sectinIndex].formFields.length > 0"
          class="mainSection"
          @click="setActiveIndex(sectinIndex)"
          :style="{ border: activeIndex === sectinIndex ? '1px solid #97a5eb' : '' }"
        >
          <div class="sectionHeader">
            <BaseText
              @input="section.name = $event"
              @focused="setActiveIndex(sectinIndex)"
              :value="section.name"
              title="عنوان بخش"
              placeholder="عنوان بخش"
              required
              :showError="sectionHeaderError"
              errortext="وارد کردن این فیلد الزامی است"
            />
          </div>
          <div
            :class="{ activeSubSection: sectionActiceIndex === subSectionIndex && activeIndex === sectinIndex }"
            @click="setSectionActiveIndex(subSectionIndex)"
            class="subSectionContainer"
            v-for="(subSection, subSectionIndex) in section.formFields"
            :key="subSectionIndex"
          >
            <div v-if="sectionActiceIndex === subSectionIndex && activeIndex === sectinIndex" class="add__remove__container">
              <div @click="addAnItem(section, sectinIndex, subSectionIndex)" class="plus__container">
                <i class="fa fa-plus"></i>
              </div>
              <div @click="removeItem(sectinIndex, subSectionIndex)" class="minus__container">
                <i class="fa fa-minus"></i>
              </div>
            </div>
            <div v-if="sectionActiceIndex === subSectionIndex && activeIndex === sectinIndex" class="change__sort__button">
              <div class="change__sort" @click="sortUp(sectinIndex, subSectionIndex)">
                <i class="fas fa-caret-up"></i>
              </div>
              <div class="change__sort" @click="sortDown(sectinIndex, subSectionIndex)">
                <i class="fas fa-caret-down"></i>
              </div>
            </div>
            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <div class="dropdownButton d-flex justify-content-between align-items-center">
                  <div>{{ subSection.fieldTypeName == 'Radio' ? 'تک انتخابی' : subSection.fieldTypeName == 'TextAreaInput' ? 'متن ثابت' : 'بله / خیر' }}</div>
                  <i style="color: #74788d" class="fas fa-caret-down"></i>
                </div>
              </template>
              <b-dropdown-item @click="changeSectionContent(sectinIndex, subSectionIndex, 'TextAreaInput')">متن ثابت</b-dropdown-item>
              <b-dropdown-item @click="changeSectionContent(sectinIndex, subSectionIndex, 'radio')">تک انتخابی</b-dropdown-item>
              <b-dropdown-item @click="changeSectionContent(sectinIndex, subSectionIndex, 'toggle')">بله / خیر</b-dropdown-item>
            </b-dropdown>
            <div class="w-100 ps-3" v-if="toggleItems">
              <TextArea
                :nameValue="subSection.name"
                v-if="subSection.fieldTypeName == 'TextAreaInput'"
                @textAreaInputChange="textAreaValueChange($event, sectinIndex, subSectionIndex)"
                :key="subSectionIndex"
              />
              <RadioSelect
                :nameValue="subSection.name"
                v-if="subSection.fieldTypeName == 'Radio'"
                @inputsDataChanged="radioSectionDataChanged($event, sectinIndex, subSectionIndex)"
                @sectionNameChange="radioSectionNameChange($event, sectinIndex, subSectionIndex)"
                @addRadioOptionClick="addRadioOption(sectinIndex, subSectionIndex)"
                @removeRadioFieldIndex="removeRadioFiled($event, sectinIndex, subSectionIndex)"
                :items="subSection.selectionRow"
                :key="radioComponentKey"
              />
              <ToggleInput
                :nameValue="subSection.name"
                v-if="subSection.fieldTypeName == 'CheckBox'"
                :toggleVal="subSection.defaultValue"
                @toggleValueChange="toggleValChange($event, sectinIndex, subSectionIndex)"
                @toggleNameChange="toggleNameChange($event, sectinIndex, subSectionIndex)"
                :key="toggleInputKey"
              />
            </div>
          </div>
        </div>
      </div>
      <Toast :title="toastText" :error="toastMode" :showToast="showToast" />
    </div>
    <div class="footer__parent d-flex justify-content-end align-items-center">
      <Button @click.native="$router.go(-1)" text="انصراف" btnClass="btn-border cancel" />
      <Button @click.native="submit()" text="ذخیره محصول" btnClass="ms-2 aprove btn-border" :loading="btnLoading" />
    </div>
  </div>
</template>

<script>
import BaseText from '@/components/common/form/formModules/BaseText.vue'
import TextArea from './section/subSection/textArea.vue'
import RadioSelect from './section/subSection/radioSelect.vue'
import ToggleInput from './section/subSection/toggleInput.vue'
import categoriesDataProvider from '../../../services/categories'
import Button from '../../common/Button.vue'
import Header from './header.vue'
import Toast from '../../common/Toast.vue'

export default {
  components: {
    BaseText,
    TextArea,
    RadioSelect,
    ToggleInput,
    Header,
    Button,
    Toast,
  },
  data() {
    return {
      btnLoading: false,
      groups: [
        {
          id: Math.random().toFixed(5).toString(),
          name: '',
          description: 'string',
          order: 1,
          createdTime: '2021-10-06T08:02:13.4548854+00:00',
          lastUpdatedTime: '2021-10-06T08:02:13.4548856+00:00',
          isAvailable: true,
          isDeleted: false,
          formFields: [
            {
              id: Math.random().toFixed(5).toString(),
              name: null,
              displayName: null,
              description: 'string',
              order: 1,
              isAvailable: true,
              isDeleted: false,
              hidden: true,
              required: true,
              cssClass: 'string',
              defaultValue: 'string',
              additionalData: 'string',
              minValueNumber: 0,
              maxValueNumber: 0,
              minLength: 0,
              maxLength: 0,
              fieldType: 2,
              fieldTypeName: 'TextAreaInput',
              selectionRow: [],
            },
          ],
        },
      ],
      activeIndex: 0,
      sectionActiceIndex: null,
      toggleItems: true,
      componentsCount: 0,
      toggleMainDiv: true,
      radioComponentKey: 1,
      toggleInputKey: 1,
      isEdited: true,
      toastText: '',
      toastMode: false,
      showToast: null,
      sectionHeaderError: false
    }
  },
  methods: {
    submit() {
      this.btnLoading = true
      this.groups.forEach((element) => {
        element.formFields.forEach((e) => {
          e.order = this.componentsCount++
        })
      })
      if (this.isEdited) {
        this.editCategoryForm() //temporarily
        // this.toastText = 'هم‌اکنون امکان ویرایش این صفحه وجود ندارد.'
        // this.toastMode = true
        // this.showToast = true
        // setTimeout(() => {
        //   this.flushToast()
        //    this.btnLoading = false
        // }, 2002)
      } else if (!this.isEdited) {
        this.createCategoryForm()
      }

      console.log(this.groups)
    },
    flushToast() {
      this.toastText = ''
      this.toastMode = false
      this.showToast = null
      return
    },
    changeSectionContent(mainIndex, secondIndex, type) {
      this.toggleItems = false
      if (type === 'TextAreaInput') {
        if (this.groups[mainIndex].formFields[secondIndex].fieldTypeName !== 'TextAreaInput') {
          this.groups[mainIndex].formFields[secondIndex] = {
            id: Math.random().toFixed(5).toString(),
            name: null,
            displayName: null,
            description: 'string',
            order: 0,
            isAvailable: true,
            isDeleted: false,
            hidden: true,
            required: true,
            createdTime: '2021-10-20T08:21:52.0490326+00:00',
            lastUpdatedTime: '2021-10-20T08:21:52.0490327+00:00',
            cssClass: 'string',
            defaultValue: 'string',
            additionalData: 'string',
            minValueNumber: 0,
            maxValueNumber: 0,
            minLength: 0,
            maxLength: 0,
            fieldType: 2,
            fieldTypeName: 'TextAreaInput',
            minValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            maxValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            selectionRow: [],
          }
        }
      } else if (type === 'radio') {
        if (this.groups[mainIndex].formFields[secondIndex].fieldTypeName !== 'Radio') {
          this.groups[mainIndex].formFields[secondIndex] = {
            id: Math.random().toFixed(5).toString(),
            name: null,
            displayName: null,
            description: 'string',
            order: 0,
            isAvailable: true,
            isDeleted: false,
            hidden: true,
            required: true,
            createdTime: '2021-10-20T08:21:52.0286552+00:00',
            lastUpdatedTime: '2021-10-20T08:21:52.0286557+00:00',
            cssClass: 'string',
            defaultValue: 'string',
            additionalData: 'string',
            minValueNumber: 0,
            maxValueNumber: 0,
            minLength: 0,
            maxLength: 0,
            fieldType: 14,
            fieldTypeName: 'Radio',
            minValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            maxValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            selectionRow: [
              {
                id: Math.random().toFixed(5).toString(),
                order: 0,
                value: null,
                text: null,
                mediaUrl: 'string',
                createdTime: '2021-10-20T08:21:52.0487087+00:00',
                lastUpdatedTime: '2021-10-20T08:21:52.0487091+00:00',
                rate: 0,
                isAvailable: true,
                isDeleted: false,
                defaultSelected: true,
              },
              {
                id: Math.random().toFixed(5).toString(),
                order: 1,
                value: null,
                text: null,
                mediaUrl: 'string',
                createdTime: '2021-10-20T08:21:52.0487087+00:00',
                lastUpdatedTime: '2021-10-20T08:21:52.0487091+00:00',
                rate: 0,
                isAvailable: true,
                isDeleted: false,
                defaultSelected: true,
              },
            ],
          }
        }
      } else {
        if (this.groups[mainIndex].formFields[secondIndex].fieldTypeName !== 'CheckBox') {
          this.groups[mainIndex].formFields[secondIndex] = {
            id: Math.random().toFixed(5).toString(),
            name: null,
            displayName: null,
            description: 'string',
            order: 0,
            isAvailable: true,
            isDeleted: false,
            hidden: true,
            required: true,
            createdTime: '2021-10-20T08:21:52.0490413+00:00',
            lastUpdatedTime: '2021-10-20T08:21:52.0490414+00:00',
            cssClass: 'string',
            defaultValue: 'true',
            additionalData: 'string',
            minValueNumber: 0,
            maxValueNumber: 0,
            minLength: 0,
            maxLength: 0,
            fieldType: 5,
            fieldTypeName: 'CheckBox',
            minValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            maxValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            selectionRow: [],
          }
        }
      }
      this.toggleItems = true
    },
    setActiveIndex(payload) {
      this.activeIndex = payload
    },
    setSectionActiveIndex(payload) {
      this.sectionActiceIndex = payload
    },
    addNewQuestion() {
      this.groups[this.activeIndex].formFields.push({
        id: Math.random().toFixed(5).toString(),
        name: null,
        displayName: null,
        description: 'string',
        order: 0,
        isAvailable: true,
        isDeleted: false,
        hidden: true,
        required: true,
        createdTime: '2021-10-20T08:21:52.0490326+00:00',
        lastUpdatedTime: '2021-10-20T08:21:52.0490327+00:00',
        cssClass: 'string',
        defaultValue: 'string',
        additionalData: 'string',
        minValueNumber: 0,
        maxValueNumber: 0,
        minLength: 0,
        maxLength: 0,
        fieldType: 2,
        fieldTypeName: 'TextAreaInput',
        minValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
        maxValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
        selectionRow: [],
      })
    },
    addNewSection() {
      this.groups.splice(0, 0, {
        name: null,
        description: 'string',
        order: 1,
        createdTime: '2021-10-06T08:02:13.4548854+00:00',
        lastUpdatedTime: '2021-10-06T08:02:13.4548856+00:00',
        isAvailable: true,
        isDeleted: false,
        formFields: [
          {
            id: Math.random().toFixed(5).toString(),
            name: null,
            displayName: null,
            description: 'string',
            order: 0,
            isAvailable: true,
            isDeleted: false,
            hidden: true,
            required: true,
            createdTime: '2021-10-20T08:21:52.0490326+00:00',
            lastUpdatedTime: '2021-10-20T08:21:52.0490327+00:00',
            cssClass: 'string',
            defaultValue: 'string',
            additionalData: 'string',
            minValueNumber: 0,
            maxValueNumber: 0,
            minLength: 0,
            maxLength: 0,
            fieldType: 2,
            fieldTypeName: 'TextAreaInput',
            minValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            maxValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
            selectionRow: [],
          },
        ],
      })
    },
    radioSectionDataChanged(payload, parentIndex, childIndex) {
      this.groups[parentIndex].formFields[childIndex].selectionRow[payload.index].value = payload.payload
      this.groups[parentIndex].formFields[childIndex].selectionRow[payload.index].text = payload.payload
    },
    removeRadioFiled(payload, parentIndex, childIndex) {
      if (this.groups[parentIndex].formFields[childIndex].selectionRow.length > 2) {
        this.groups[parentIndex].formFields[childIndex].selectionRow.splice(payload, 1)
        this.radioComponentKey += 1
      }
    },
    radioSectionNameChange(payload, parentIndex, childIndex) {
      this.groups[parentIndex].formFields[childIndex].name = payload
      this.groups[parentIndex].formFields[childIndex].displayName = payload
    },
    addRadioOption(parentIndex, childIndex) {
      this.groups[parentIndex].formFields[childIndex].selectionRow.push({
        id: Math.random().toFixed(5).toString(),
        order: this.groups[parentIndex].formFields[childIndex].selectionRow.length,
        value: null,
        text: null,
        mediaUrl: 'string',
        createdTime: '2021-10-20T08:21:52.0487087+00:00',
        lastUpdatedTime: '2021-10-20T08:21:52.0487091+00:00',
        rate: 0,
        isAvailable: true,
        isDeleted: false,
        defaultSelected: true,
      })
      // setTimeout(() => {
      this.radioComponentKey += 1
      // }, 250);
    },
    textAreaValueChange(payload, parentIndex, childIndex) {
      this.groups[parentIndex].formFields[childIndex].name = payload
      this.groups[parentIndex].formFields[childIndex].displayName = payload
    },
    toggleValChange(payload, parentIndex, childIndex) {
      if (payload === true) {
        this.groups[parentIndex].formFields[childIndex].defaultValue = 'true'
      } else {
        this.groups[parentIndex].formFields[childIndex].defaultValue = 'false'
      }
    },
    toggleNameChange(payload, parentIndex, childIndex) {
      this.groups[parentIndex].formFields[childIndex].name = payload
      this.groups[parentIndex].formFields[childIndex].displayName = payload
    },
    sortUp(parentIndex, childIndex) {
      if (this.sectionActiceIndex !== 0) {
        this.toggleMainDiv = false
        var tempVal = this.groups[parentIndex].formFields[childIndex]
        this.groups[parentIndex].formFields[childIndex] = this.groups[parentIndex].formFields[childIndex - 1]
        this.groups[parentIndex].formFields[childIndex - 1] = tempVal
        this.sectionActiceIndex -= 1
        this.activeIndex = childIndex

        this.toggleMainDiv = true
      }
    },
    sortDown(parentIndex, childIndex) {
      if (this.groups[parentIndex].formFields.length - 1 > childIndex) {
        console.log('this.sectionActiceIndex', this.sectionActiceIndex)
        this.toggleMainDiv = false
        var tempVal = this.groups[parentIndex].formFields[childIndex]
        this.groups[parentIndex].formFields[childIndex] = this.groups[parentIndex].formFields[childIndex + 1]
        this.groups[parentIndex].formFields[childIndex + 1] = tempVal
        this.sectionActiceIndex += 1
        this.activeIndex = childIndex
        console.log('this.groups', this.groups, 'this.sectionActiceIndex', this.sectionActiceIndex)
        this.toggleMainDiv = true
      }
    },
    removeItem(parentIndex, childIndex) {
      this.groups[parentIndex].formFields.splice(childIndex, 1)
    },
    addAnItem(payload, parentIndex, childIndex) {
      // console.log('payload', payload, 'parentIndex', parentIndex, 'childIndex', childIndex)
      // payload.formFields[childIndex].id = Math.random().toFixed(5).toString()
      // setTimeout(() => {

      //   this.groups[parentIndex].formFields.splice(childIndex, 0, payload.formFields[childIndex])
      // }, 1000);
      // // this.groups[parentIndex].formFields.push(payload.formFields[childIndex])

      this.groups[this.activeIndex].formFields.splice(childIndex, 0, {
        id: Math.random().toFixed(5).toString(),
        name: null,
        displayName: null,
        description: 'string',
        order: 0,
        isAvailable: true,
        isDeleted: false,
        hidden: true,
        required: true,
        createdTime: '2021-10-20T08:21:52.0490326+00:00',
        lastUpdatedTime: '2021-10-20T08:21:52.0490327+00:00',
        cssClass: 'string',
        defaultValue: 'string',
        additionalData: 'string',
        minValueNumber: 0,
        maxValueNumber: 0,
        minLength: 0,
        maxLength: 0,
        fieldType: payload.formFields[childIndex].fieldType,
        fieldTypeName: payload.formFields[childIndex].fieldTypeName,
        minValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
        maxValueDateTimeOffset: '2021-08-31T11:54:06.461+00:00',
        selectionRow:
          payload.formFields[childIndex].fieldTypeName == 'Radio'
            ? [
                {
                  id: Math.random().toFixed(5).toString(),
                  order: 0,
                  value: null,
                  text: null,
                  mediaUrl: 'string',
                  createdTime: '2021-10-20T08:21:52.0487087+00:00',
                  lastUpdatedTime: '2021-10-20T08:21:52.0487091+00:00',
                  rate: 0,
                  isAvailable: true,
                  isDeleted: false,
                  defaultSelected: true,
                },
                {
                  id: Math.random().toFixed(5).toString(),
                  order: 0,
                  value: null,
                  text: null,
                  mediaUrl: 'string',
                  createdTime: '2021-10-20T08:21:52.0487087+00:00',
                  lastUpdatedTime: '2021-10-20T08:21:52.0487091+00:00',
                  rate: 0,
                  isAvailable: true,
                  isDeleted: false,
                  defaultSelected: true,
                },
              ]
            : null,
      })
      this.radioComponentKey += 1
      payload.formFields[childIndex].fieldTypeName == 'CheckBox' && this.toggleInputKey++
    },
    createCategoryForm() {
      categoriesDataProvider
        .createCategoryFormBuilder({
          categoryid: this.$route.params.id,
          createFormDto: {
            name: '',
            displayName: '',
            icon: 'string',
            isAvailable: true,
            description: 'string',
            conditions: 'string',
            order: 0,
            tenantid: Math.random().toFixed(5).toString(),
            userid: Math.random().toFixed(5).toString(),
            objectid: Math.random().toFixed(5).toString(),
            serviceid: Math.random().toFixed(5).toString(),
            additionalData: 'string',
            groups: this.groups,
          },
        })
        .then((res) => {
          console.log(res.data.data)
          this.$router.push({ path: '/categories' })
          this.btnLoading = false
        })
        .catch((err) => {
          this.btnLoading = false
        })
    },
    editCategoryForm() {
      categoriesDataProvider
        .editCategoryFormBuilder({
          categoryid: this.$route.params.id,
          editFormDto: {
            id: 'string',
            name: 'string',
            displayName: 'string',
            guidName: 'string',
            icon: 'string',
            isAvailable: true,
            description: 'string',
            conditions: 'string',
            additionalData: 'string',
            order: 0,
            groups: this.groups,
          },
        })
        .then((res) => {
          console.log(res.data.data)
          this.$router.push({ path: '/categories' })
          this.btnLoading = false
        })
        .catch((err) => {
          this.btnLoading = false
        })
    },
  },
  mounted() {
    if (this.$route.params.id) {
      categoriesDataProvider.getCategoryFormBuilder({ categoryId: this.$route.params.id }).then((res) => {
        if (res.data.data.form !== null) {
          let tempGroup = []
          for (let i = 0; i < res.data.data.form.groups.length; i++) {
            let temp = {
              id: res.data.data.form.groups[i].id,
              name: res.data.data.form.groups[i].name,
              description: res.data.data.form.groups[i].description,
              order: res.data.data.form.groups[i].order,
              formFields: res.data.data.form.groups[i].formFields,
            }
            tempGroup.push(temp)
          }
          console.log('tempGroup', tempGroup)
          this.groups = tempGroup
        } else {
          this.isEdited = false
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.mainContainer {
  background: white;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  height: calc(100vh - 310px);
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.mainContainer::-webkit-scrollbar {
  display: none;
}
.mainSection {
  border: 1px solid #f0f1f1;
  margin-bottom: 20px;
  border-radius: 5px;
}
.sectionHeader {
  padding: 30px;
  border-radius: 5px 5px 0 0;
  background: #f8f9fa;
}
.subSectionContainer {
  padding: 30px;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: flex-start;
  position: relative;
}
.subSectionContainer:last-child {
  border-radius: 5px;
}
.dropdownButton {
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 4px;
  width: 200px;
  height: 32px;
  padding-right: 20px;
  padding-left: 12px;
}
::v-deep .dropdown-toggle {
  padding: 0 !important;
  color: #444444 !important;
  font-size: 12px !important;
}

.secondary__button {
  padding: 8px 18px;
  color: white;
  background: #74788d;
  border-radius: 5px;
  font-size: 13px;
}
.primary__button {
  background-color: #556ee6;
  padding: 8px 18px;
  box-shadow: none;
  color: white;
  border-radius: 5px;
  font-size: 13px;
  margin-right: 10px;
}
.footer__parent {
  margin-bottom: 20px;
}
.activeSubSection {
  background: #f8f9fa;
  border-top: 1px dashed #ced4da;
  border-bottom: 1px dashed #ced4da;
  &:last-child {
    border-bottom: none;
  }
}
.add__remove__container {
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
}
.plus__container {
  background: #34c38f;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 10px;
  i {
    color: white;
  }
}
.minus__container {
  background: #ff4861;
  padding: 0 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  i {
    color: white;
  }
}
.change__sort__button {
  position: absolute;
  right: -7px;
  top: 50%;
  transform: translateY(-50%);
}
.change__sort {
  background: #74788d;
  padding: 5px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: white;
    font-size: 10px;
  }
}
.alert.alert-popUp.alert-dismissible.alert-info {
  padding: 0;
}
</style>
